import {
  GenericCarouselItem,
  GenericCarouselScrollView,
} from 'lib/common/components/GenericCarousel';
import { useGetMerchantProductsQuery } from 'lib/shop/api';
import { MerchantDetail } from 'lib/shop/types';
import { useRouter } from 'next/router';
import React from 'react';

export default function MerchantProducts({
  merchant,
}: {
  merchant: MerchantDetail;
}) {
  const router = useRouter();

  const { data: products, isLoading: isProductsLoading } =
    useGetMerchantProductsQuery({
      merchantIdOrSlug: merchant.id as string,
    });

  return (
    <>
      {!isProductsLoading && products && products.length > 0 && (
        <div className="pb-4">
          <div className="my-2">
            <h3>Featured products</h3>
          </div>

          <div className="pt-6">
            <GenericCarouselScrollView fullWidth>
              {products?.map(product => (
                <GenericCarouselItem
                  item={product}
                  key={product.id}
                  title={product.title}
                  subtitle={
                    <>
                      {product?.price}
                      {product?.compare_at_price && (
                        <>
                          {' '}
                          <span className="text-sm leading-5 line-through">
                            {product?.compare_at_price}
                          </span>
                        </>
                      )}
                    </>
                  }
                  imageUrl={product.images?.[0]?.url}
                  logoAsset={merchant?.logo_image}
                  onTappedItem={() => {
                    router.push(
                      `/shop/redirect/${merchant.id}/product/${product.id}`,
                    );
                  }}
                />
              ))}
            </GenericCarouselScrollView>
          </div>
          <div className="py-5">
            <div className="h-px w-full border-t border-gray-300"></div>
          </div>
        </div>
      )}
    </>
  );
}
